
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { getCurrency } from '@/utils/cookies'
import { getEnterprise, setEnterprise } from '@/api/universal'
import { dateToSeconds, getCurrentDate } from '@/utils/dateTime'
import { ElForm } from 'element-ui/types/form'

@Component({
  name: 'holidayConfig',
  components: {}
})
export default class extends Vue {
  private currencyTypes: any[] = AppModule.enterprise.available_currency
  private queryForm = {
    currency: getCurrency() || AppModule.currentCurrencyType || 'THB'
  }
  private loading: boolean = false
  private setForm: any = {
    currency: '',
    title: '',
    start_time: null,
    end_time: null
  }
  private date: any[] = []

  private holidaysData: any = {}

  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.setForm.start_time = dateToSeconds(this.date[0])
      this.setForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.setForm.start_time = null
      this.setForm.end_time = null
    }
  }

  // 货币切换
  private async currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.init()
  }

  private get holidaysList(): any[] {
    return this.holidaysData[this.queryForm.currency] || []
  }

  private async init() {
    this.loading = true
    try {
      const res: any = await getEnterprise()
      this.holidaysData = res.ssl_switch.holidays_settlement_time || {}
      this.loading = false
    } catch (error) {
      this.loading = false
    }
  }

  private openAddHolidaydialog: boolean = false

  private addHoliday() {
    this.openAddHolidaydialog = true
  }

  private closeHoliday() {
    this.openAddHolidaydialog = false
    this.setForm = {
      title: '',
      start_time: null,
      end_time: null
    }
  }

  private submitForm() {
    ;(this.$refs.setForm as ElForm).validate(async valid => {
      if (!valid) return
      this.loading = true
      const currency = this.queryForm.currency
      const newHoliday = {
        title: this.setForm.title,
        start_time: this.setForm.start_time,
        end_time: this.setForm.end_time
      }

      if (!this.holidaysData[currency]) {
        this.holidaysData[currency] = []
      }

      this.holidaysData[currency].push(newHoliday)
      let data: any = {
        ssl_switch: {
          holidays_settlement_time: this.holidaysData
        }
      }

      try {
        await setEnterprise(data)
        this.$message({
          message: '操作成功！',
          type: 'success'
        })
        this.loading = false
        this.closeHoliday()
        this.init()
      } catch (error) {
        console.error(error)
        this.loading = false
      }
    })
  }

  private deleteHoliday(index: number) {
    this.$confirm('此操作将永久删除该节假日配置, 是否继续?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async () => {
        this.loading = true
        const currency = this.queryForm.currency
        const updatedHolidays = [...this.holidaysData[currency]]
        updatedHolidays.splice(index, 1)

        this.holidaysData[currency] = updatedHolidays

        let data: any = {
          ssl_switch: {
            holidays_settlement_time: this.holidaysData
          }
        }

        try {
          await setEnterprise(data)
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
          this.loading = false
          this.init()
        } catch (error) {
          console.error(error)
          this.loading = false
        }
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
  }

  mounted() {
    this.init()
  }

  private getDayCount(startStr, endStr) {
    const startDate: any = new Date(startStr * 1000)
    const endDate: any = new Date(endStr * 1000)
    const oneDay = 24 * 60 * 60 * 1000
    // 计算相差毫秒 -> 转换为天数
    const diffMs = endDate - startDate
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
    return diffDays >= 0 ? diffDays + 1 : 0 // 包含首尾两天，所以加1
  }
}
